import withStyles from '@mui/styles/withStyles';
import classNames from "classnames";
import {color, radius} from "common/tokens";
import React, {useRef, useState, useEffect} from "react";
import * as propTypes from "prop-types";
import MoodIcon from '@mui/icons-material/Mood';
import Close from '@mui/icons-material/Close';
import GifOutlinedIcon from '@mui/icons-material/GifOutlined';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Send from '@mui/icons-material/Send';
import {isEmpty} from 'lodash';
import GifSearchBox from 'components/Chat/GifSearchBox'
import './chat.css'
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import {useTranslation} from "react-i18next";
import { truncateFileName, getFileExtensionFromName } from "common/helpers";
import { MentionsInput, Mention } from 'react-mentions'
import config from "common/config";
import Avatar from "@mui/material/Avatar";
import { fetchLinkPreview } from "api/chatApi";

let emojiPickerModules;
export const loadEmojiPicker = () => {
  emojiPickerModules = emojiPickerModules || Promise.all([
    import('@emoji-mart/react'),
    import('@emoji-mart/data/sets/15/google.json'),
  ]);
  return emojiPickerModules;
};

const styles = theme => ({
  attachmentWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    backgroundColor:'white',
    color:'black',
    fontWeight: 'bold',
    fontSize: 12,
    padding:4,
    borderRadius: 6,
    margin: 0,
    marginTop: 2,
    marginBottom: 6,
    shadowColor: 'transparent',
    width: 'min-content',
    whiteSpace: 'nowrap'
  },
  // A composer on the surface with a pill field, rather than a grey tray.
  wrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    flex: 1,
    padding: '12px 16px',
    borderTop: `1px solid ${color.DIVIDER}`,
    background: color.SURFACE,
  },
  // The send action is the one filled control down here, so it reads as the
  // button it is instead of a bare glyph.
  sendButtonIdle: {
    background: color.DIVIDER,
    color: color.TEXT_SUBTLE,
    cursor: 'default',
  },
  sendButton: {
    appearance: 'none',
    border: 'none',
    padding: 0,
    marginLeft: 12,
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: '50%',
    background: color.ACCENT,
    color: color.ON_ACCENT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  // Sized to the button rather than inheriting a 35px glyph, which overflowed
  // the circle and read as a black wedge.
  sendIcon: {
    fontSize: 20,
  },
  fieldActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexShrink: 0,
    marginLeft: 8,
  },
  fieldAction: {
    color: color.TEXT_MUTED,
    padding: 4,
  },
  whiteTextBoxContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    borderRadius: radius.PILL,
    padding: '6px 14px',
    background: color.SURFACE_MUTED,
    color: color.TEXT,
  },
  transparentTextBoxContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    borderRadius: radius.PILL,
    padding: '6px 14px',
    backgroundColor: 'transparent',
  },
  textFieldWrapper: {
    flex: 1,
    minWidth: 0,
  },
  trayPaper: {
    borderRadius: 14,
    overflow: 'hidden',
    marginTop: -8,
    // A phone is narrower than the picker's natural width, and a Popover
    // cannot reposition a paper that is wider than the viewport.
    maxWidth: 'calc(100vw - 16px)',
  },
  emojiTray: {
    width: 352,
    maxWidth: 'calc(100vw - 16px)',
  },
  tray: {
    width: 360,
    maxWidth: '90vw',
    height: 320,
    overflowY: 'auto',
    padding: 12,
    boxSizing: 'border-box',
  },
  messageAttachmentName: {
    fontWeight: '500',
    color: 'black',
  },
  messageAttachmentExtension: {
    fontWeight: '700',
    color: '#E0B334',
  },
  clearAttachment: {
    color: '#1C1B1F',
    opacity: 0.4,
    fontSize: 16,
    marginLeft: 5,
    cursor: 'pointer'
  },
  fileUploadAlertMessage: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: '500',
    fontSize: 10,
    opacity: 0.7,
    marginTop: 6,
  },
  alertOutline: {
    marginTop: 1,
    marginRight: 4,
    fontSize: 12,
  },
  mentionListiing: {
    display: 'flex',
    alignItems: 'cemter',
  },
  smallAvatar: {
    width: 16,
    height: 16,
    marginRight: 4,
  },
  previewContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff;',
    padding: 20,
    position: 'relative'
  },
  linkPreviewImage: {
    width: 60,
    height: 60,
    borderRadius: 4,
    marginRight: 10
  },
  previewContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 1.2
  },
  description: {
    fontSize: 12,
    color: '#000',
    fontWeight: 400,
    margin: 5
  },
  url: {
    fontSize: 12,
    color: '#0B57D0',
    textDecoration: 'none',
  },
  closeButton: {
    background: 'transparent',
    border: 'none',
    color: '#000',
    fontSize: 16,
    cursor: 'pointer',
    position: 'absolute',
    top: 5,
    right: 5,
    fontWeight: 'bold'
  },
});


const MessageInputBox = ({classes, placeHolder, onSendClick, myId, channelId, myEmail, channelMembers, addNewMessageToChannel, setSelectedMessageId, isAIChannel, onStartRatingCountDown, setIsNewMessageLoading}) => {
  const {GIPHY_SDK_KEY} = config;
  const [messageText, setMessageText] = useState("");
  const fileInputRef = useRef(null);
  const [isAttachmentAdded, setIsAttachmentAdded] = useState(false);
  const [messageAttachments, setMessageAttachments] = useState([]);
  const emojiAnchor = useRef(null);
  const gifAnchor = useRef(null);
  const [showEmojiTray, setShowEmojiTray] = useState(false);
  const [showGifTray, setShowGifTray] = useState(false);
  const {t} = useTranslation();
  const supportedFileFormat = ['.jpg', '.jpeg', '.gif', '.png', '.webp', '.heic', '.txt', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.csv', '.ppt', '.pptx'];
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [previewData, setPreviewData] = useState({})
  const lastDetectedUrlRef = useRef(null);

  const [emojiPicker, setEmojiPicker] = useState(null);
  const emojiPopoverActions = useRef(null);

  useEffect(() => {
    loadEmojiPicker().then(([picker, data]) => setEmojiPicker({Picker: picker.default, data: data.default}));
  }, []);

  // The tray opens empty if tapped before the picker has loaded, so it has to
  // be placed again once the picker gives it a height.
  useEffect(() => {
    emojiPopoverActions.current?.updatePosition();
  }, [emojiPicker]);

  const activeChannelMembers = channelMembers.filter((channelMember) => channelMember.isActive)
  const channelMembersExcludingMe = activeChannelMembers.filter((channelMember) => channelMember.userId !== myId);
  const fetchUsers = () => {
    if (channelMembersExcludingMe.length > 0) {
      const tagsArray = channelMembersExcludingMe.map(member => {
        return {
          id: member.userId,
          display: member.userFullName,
          image: member.displayPicture
        }
      })
      return tagsArray
    }
    return []
  }

  const previewRequestId = useRef(0);

  const extractUrl = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const matches = text.match(urlRegex);
    return matches ? matches[0] : null;
  };

  const tagListData = fetchUsers()

  const selectAttachment = () => {
    fileInputRef.current.click();
  }

  const clearFileSelection = () => {
    setMessageAttachments([])
    setIsAttachmentAdded(false)
  }

  const handleGifSelection = (item) => {
    setShowGifTray(false)
    const file = {
      url: item.images.downsized_medium.url,
      type: 'gif',
      name: item.title + '.gif'
    }
    setMessageAttachments([file])
    setIsAttachmentAdded(true)
  }

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    const validFiles = [];

    if (selectedFiles) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        if (!supportedFileFormat.includes('.' + getFileExtensionFromName(file.name))) {
          alert('Please select a valid file. \nSupported images are: jpeg, jpg, gif, png, webp, heic \nSupported documents are: txt, pdf, csv, doc, docx, xls, xlsx, ppt, pptx')
          return
        }

        if (file.size <= maxSizeInBytes) {
          validFiles.push(file);
        }
      }
    }

    setMessageAttachments(validFiles);

    if (validFiles.length > 0) {
      setIsAttachmentAdded(true)
    }

    if (validFiles.length != selectedFiles.length) {
      alert('Files with more than 5 MB are not allowed.')
    }
  };

  useEffect(() => {
    if (debounceTimer) clearTimeout(debounceTimer);

    const timer = setTimeout(async () => {
      const url = extractUrl(messageText);
      if (url && url !== lastDetectedUrlRef.current) {
        const requestId = ++previewRequestId.current;
        try {
          const result = await fetchLinkPreview(url);
          if (requestId === previewRequestId.current) {
            setPreviewData(result);
            lastDetectedUrlRef.current = url;
          }
        } catch (error) {
          console.error("Failed to fetch preview:", error);
        }
      } else if (!url) {
        setPreviewData({});
        lastDetectedUrlRef.current = null;
      }
    }, 700);

    setDebounceTimer(timer);

    return () => clearTimeout(timer);
  }, [messageText]);

  const onSend = () => {
    if (!isMessageEmpty(messageText) || isAttachmentAdded) {
      let tempId = null;
      if (!isEmpty(messageAttachments)) {
        tempId = (Math.random() + 1).toString(36).substring(2);
        const messageData = prepareTempMessageData(tempId);
        addNewMessageToChannel(messageData);
      }

      let message = {
        from: myEmail,
        text: messageText,
        channelId: channelId,
        attachments: messageAttachments,
        tempId: tempId
      };

      setSelectedMessageId(null);
      onSendClick(message);
      onStartRatingCountDown();
      clearMessage();
      clearFileSelection();

      previewRequestId.current++;

      if (isAIChannel) {
        const timeoutId = setTimeout(() => {
          setIsNewMessageLoading(true);
        }, 500);
        return () => clearTimeout(timeoutId);
      }
    }
  };

  const prepareTempMessageData = (tempId) => {
    return {
      channel_id: channelId,
      msg_id: tempId,
      temp_id: tempId,
      created_on: Date(),
      user_id: myId,
      message: messageText,
      command: "new_message",
      attachments: JSON.stringify([{
        id: (Math.random() + 1).toString(36).substring(2),
        attachment_name: truncateFileName(messageAttachments[0].name, 13) + ' .' + getFileExtensionFromName(messageAttachments[0].name),
        presigned_url: null,
        thumbnail_presigned_url: null
      }]),
      status: 'in-progress'
    }
  }

  const clearMessage = () => {
    setMessageText("");
    setPreviewData({});
    lastDetectedUrlRef.current = null;
  };

  const isMessageEmpty = (message) => isEmpty(message);
  const addEmojiToTextBox = (emoji) => {
    setMessageText(messageText + emoji.native);
  }

  const handleKeyPress = (event) => {
    if (event.keyCode === 13 && !event.shiftKey) {
      onSend();
      event.preventDefault()
    }
  };

  const handleTextInput = (value) => {
    setMessageText(value);

    if (debounceTimer) clearTimeout(debounceTimer);

    const timer = setTimeout(async () => {
      const url = extractUrl(value);
      if (url && url !== lastDetectedUrlRef.current) {
        try {
          const data = await fetchLinkPreview(url);
          setPreviewData(data);
          lastDetectedUrlRef.current = url;
        } catch (err) {
          console.error("Failed to fetch link preview", err);
          setPreviewData({});
        }
      } else if (!url) {
        setPreviewData({});
        lastDetectedUrlRef.current = null;
      }
    }, 2000);

    setDebounceTimer(timer);
  };

  const canSend = !isMessageEmpty(messageText) || isAttachmentAdded;

  return (
    <div>
      <div className={classes.wrapper}>
        <div
          style={{
            width: '100%',
          }}
        >
          { isAttachmentAdded &&
            <div
              className={classes.attachmentWrapper}
            >
              <span
                className={classes.messageAttachmentName}
              >
                {truncateFileName(messageAttachments[0].name, 13)}
              </span>
              <span
                className={classes.messageAttachmentExtension}
              >
                .{getFileExtensionFromName(messageAttachments[0].name)}
              </span>
              <Close
                className={classes.clearAttachment}
                onClick={() => clearFileSelection()}
              />
            </div>
          }
          {/* The field is a pill and the send button is present from the start,
              rather than both appearing once there is something to send. */}
          <div className={classes.whiteTextBoxContainer}>
          <div className={classes.textFieldWrapper}>
            {!isAIChannel ? (
              <MentionsInput
                style={{
                  suggestions: {
                    list: {
                      backgroundColor: "#FFF",
                      fontSize: 12,
                      borderRadius: 8,
                    },
                    item: {
                      color: 'rgba(0, 0, 0, 0.50)',
                      fontSize: 12,
                      fontWeight: 400,
                      "&focused": {
                        backgroundColor: "rgb(238, 238, 238)",
                      },
                      border: 0,
                      borderRadius: 8,
                      paddingTop: 3,
                      paddingBottom: 3,
                    },
                  }
                }}
                className={'chat-mentions'}
                placeholder={placeHolder || t('Type your Message here')}
                value={messageText}
                onKeyDown={handleKeyPress}
                onChange={(e) => handleTextInput(e.target.value)}
                multiline
                autoFocus
                allowSpaceInQuery={true}
                forceSuggestionsAboveCursor={true}
              >
                <Mention
                  className={'mentions__mention'}
                  trigger="@"
                  data={tagListData}
                  appendSpaceOnAdd
                  displayTransform={(id, display) => '@'+display}
                  renderSuggestion={(suggestion, search, highlightedDisplay  ) => (
                    <div className={classes.mentionListiing}>
                      <Avatar src={suggestion.image} alt={suggestion.display} className={classes.smallAvatar}/>
                      <div className="mention-info">
                        <div>{highlightedDisplay}</div>
                      </div>
                    </div>
                  )}
                />
              </MentionsInput>
            ) : (
              <input
                placeholder={placeHolder || t('Type your Message here')}
                value={messageText}
                onKeyDown={handleKeyPress}
                onChange={(e) => handleTextInput(e.target.value)}
                multiline
                autoFocus
                style={{
                  width: '100%',
                  border: 'none',
                  outline: 'none',
                  padding: '8px',
                  background: 'transparent',
                  fontSize: '14px',
                }}
              />
            )}
          </div>
            {/* Composing controls sit at the right end of the field, so the
                message itself starts at the left edge. Send stays outside it. */}
            <div className={classes.fieldActions}>
              {!isAIChannel &&
                <IconButton ref={emojiAnchor} size={'small'} className={classes.fieldAction} onClick={() => {setShowGifTray(false); setShowEmojiTray(!showEmojiTray)}}>
                  <MoodIcon fontSize={'small'}/>
                </IconButton>
              }
              {!isAttachmentAdded && !isAIChannel &&
                <IconButton ref={gifAnchor} size={'small'} className={classes.fieldAction} onClick={() => {setShowEmojiTray(false); setShowGifTray(!showGifTray);}}>
                  <GifOutlinedIcon style={{fontSize: 26}}/>
                </IconButton>
              }
              {!isAttachmentAdded && !isAIChannel &&
                <>
                  <input
                    type="file"
                    ref={fileInputRef}
                    hidden
                    onClick={(e) => {e.target.value = null}}
                    onChange={handleFileChange}
                    accept={supportedFileFormat.join(',')}
                  />
                  <IconButton size={'small'} className={classes.fieldAction} onClick={() => selectAttachment()}>
                    <AttachFileIcon fontSize={'small'}/>
                  </IconButton>
                </>
              }
            </div>
          </div>
          { isAttachmentAdded && isMessageEmpty(messageText) &&
            <div className={classes.fileUploadAlertMessage}>
              <ErrorOutline
                className={classes.alertOutline}
              />
              <div>Files sent cannot be deleted. Verify before sending</div>
            </div>
          }
        </div>
        <button
          type={'button'}
          aria-label={t('send')}
          disabled={!canSend}
          className={classNames(classes.sendButton, !canSend && classes.sendButtonIdle)}
          onClick={canSend ? onSend : undefined}
        >
          <Send className={classes.sendIcon}/>
        </button>
      </div>
      <Popover
        open={showGifTray}
        anchorEl={gifAnchor.current}
        onClose={() => setShowGifTray(false)}
        classes={{paper: classes.trayPaper}}
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        transformOrigin={{vertical: 'bottom', horizontal: 'right'}}
        marginThreshold={8}
      >
        <div className={classes.tray}>
          <GifSearchBox
            apiKey={GIPHY_SDK_KEY}
            onSelect={handleGifSelection}
            gifPerPage={10}
            autoFocus
          />
        </div>
      </Popover>

      <Popover
        open={showEmojiTray}
        action={emojiPopoverActions}
        anchorEl={emojiAnchor.current}
        onClose={() => setShowEmojiTray(false)}
        classes={{paper: classes.trayPaper}}
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        transformOrigin={{vertical: 'bottom', horizontal: 'right'}}
        marginThreshold={8}
      >
        <div className={classes.emojiTray}>
          {emojiPicker && (
            <emojiPicker.Picker
              data={emojiPicker.data}
              set={'google'}
              previewPosition={'none'}
              skinTonePosition={'none'}
              navPosition={'top'}
              theme={'light'}
              dynamicWidth
              onEmojiSelect={addEmojiToTextBox}
            />
          )}
        </div>
      </Popover>
      {previewData?.title && (
        <div className={classes.previewContainer}>
          <div>
            {previewData.image && (
              <img src={previewData.image} alt="linkPreviewImage" className={classes.linkPreviewImage} />
            )}
          </div>
          <div className={classes.previewContent}>
            <strong className={classes.title}>{previewData.title}</strong>
            {previewData.description && (
              <p className={classes.description}>{previewData.description}</p>
            )}
            {previewData.url && (
              <a href={previewData.url.startsWith("http") ? previewData.url : `https://${previewData.url}`} target="_blank" rel="noopener noreferrer" className={classes.url}>
                {previewData.url}
              </a>
            )}
          </div>
          <button onClick={() => setPreviewData(null)} className={classes.closeButton}>✕</button>
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(MessageInputBox);

MessageInputBox.propTypes = {
  isDisabled: propTypes.bool,
  enableEmoji: propTypes.bool,
  placeHolder: propTypes.string,
  onSendClick: propTypes.func,
  myId: propTypes.number,
  isFullScreen: propTypes.bool
};

MessageInputBox.defaultProps = {
  enableEmoji: false,
  isDisabled: false,
  isFullScreen: false
};
